<template>
  <a-entity position="0 2 0" @loaded="loaded" />
</template>

<script>
// import { MeshLine, MeshLineMaterial } from 'three.meshline'
import './utils/Maf'
import { MeshLine, MeshLineMaterial } from './utils/THREE.MeshLine'

export default {
  name: 'Lines',
  methods: {
    loaded() {
      return
      const geometry = new THREE.Geometry()
      const points = [
        new THREE.Vector3(0, 0 ,0),
        new THREE.Vector3(2, 1 ,0),
        new THREE.Vector3(4, 0 ,0),
        new THREE.Vector3(6, .5 ,0)
      ]

      geometry.vertices = new THREE.CatmullRomCurve3(points).getPoints(40)

      var line = new MeshLine()
      line.setGeometry(geometry, p => 1 * Maf.parabola( p, 1 ))

       const material = new MeshLineMaterial( {
        color: new THREE.Color(0xffffff),
        resolution: new THREE.Vector2( window.innerWidth, window.innerHeight ),
        lineWidth: .1,
        near: 0.005,
        far: 10000,
        transparent: true
      })

      const mesh = new THREE.Mesh(line.geometry, material)
      const uniforms = mesh.material.uniforms

      this.$el.object3D.add(mesh)

      //

      const tl = new TimelineLite()
        .from([uniforms.visibility, uniforms.opacity], 2, { value: 0, delayRepeat: 3, repeat: -1, yoyo: true })
        // .from(mesh.scale, 2, { x: .5, repeat: -1, yoyo: true })
        // .from(mesh.position, 2, { x: -2, repeat: -1, yoyo: true })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lines/Lines.vue